import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { LIST_PAYMENT_CARDS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { CardTokenType } from '@features/PaymentService/types/paymentService.types';

import type { GetListCardsResult } from '../types/getListCards.types';

export const LIST_CARDS = 'ListCards';
export const getListCards = (builder: BuilderType) =>
  builder.query<CardTokenType[], void>({
    providesTags: [LIST_CARDS],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: LIST_PAYMENT_CARDS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetListCardsResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result.Cards;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
